/**
 * SirenIcon — small inline SVG used by CustomerTicketAlarm.
 * Kept as a separate component so the topbar bundle can tree-shake
 * against phosphor-icons without importing the full weight of another
 * icon set.
 */
import React from "react";

export function SirenIcon({ size = 18, weight = "regular", className = "" }) {
  const fill = weight === "fill" ? "currentColor" : "none";
  const stroke = "currentColor";
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      className={className}
      aria-hidden="true"
    >
      {/* Base */}
      <rect x="4" y="16" width="16" height="4" rx="1" fill={fill} stroke={stroke} strokeWidth="1.5"/>
      {/* Dome */}
      <path
        d="M6 16v-4a6 6 0 0 1 12 0v4"
        fill={fill}
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      {/* Highlight stripe */}
      <path
        d="M9 16v-4a3 3 0 0 1 3-3"
        fill="none"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        opacity="0.55"
      />
      {/* Light beam ticks */}
      <path d="M12 3v2" stroke={stroke} strokeWidth="1.5" strokeLinecap="round"/>
      <path d="M4.5 7l1.4 1.4" stroke={stroke} strokeWidth="1.5" strokeLinecap="round"/>
      <path d="M19.5 7l-1.4 1.4" stroke={stroke} strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  );
}
